// src/slices/navbar/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Get All Nav Items
export const getNavItems = createAsyncThunk("navItem/getAll", async ({ search = "", page = 1, limit = 10 } = {}, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/nav-item/all`, { params: { search, page, limit } });
    return response;
  } catch (error) {
    return rejectWithValue(error.response?.data || { message: "Failed to fetch nav items" });
  }
});

// Get Single Nav Item
export const getNavItemById = createAsyncThunk("navItem/getOne", async (id, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/nav-item/${id}`);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || { message: "Failed to fetch nav item" });
  }
});
